// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "main[data-v-d402c91a]{width:min(603px,100%);min-height:60vh;margin:min(128px,13vh) auto;display:flex;flex-direction:column;align-items:center;grid-gap:44px;gap:44px}h1[data-v-d402c91a]{margin:0;font-size:2.4rem;color:#444}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
